import React, { Component, Fragment } from 'react';
import { ShopHeader } from '../../header';
import { ShopLayout as Layout } from '../../layout';
import ConnectedHits from './hits';
import Filter from '../../../containers/filter';
import AlgoliaWrapper from '../../algoliawrapper';
import { ResponsiveFilter } from '../../../containers/ui';

class Shop extends Component {
  render() {
    return (
      <AlgoliaWrapper
        appID={process.env.REACT_APP_ALGOLIA_APP_ID}
        apiKey={process.env.REACT_APP_ALGOLIA_API_KEY}
        indexName="dev_articles"
        render={({ filterReset }) => {
          return (
            <Fragment>
              <Layout>
                <Layout.Header id="layout-header">
                  <ShopHeader />
                </Layout.Header>
                <Layout.BodyWrapper id="layout-body-wrapper">
                  <Fragment>
                    <Layout.LeftBody id="layout-left-body">
                      <Filter id="filter" onFilterReset={filterReset} />
                    </Layout.LeftBody>
                    <Layout.RightBody id="layout-body-right">
                      <ConnectedHits />
                    </Layout.RightBody>
                  </Fragment>
                </Layout.BodyWrapper>
              </Layout>
              <ResponsiveFilter />
            </Fragment>
          );
        }}
      />
    );
  }
}

export default Shop;



// WEBPACK FOOTER //
// ../shop_main/components/views/shop/index.js